import script from "./password.vue?vue&type=script&setup=true&lang=js"
export * from "./password.vue?vue&type=script&setup=true&lang=js"

import "./password.vue?vue&type=style&index=0&id=b3f4f020&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/boeingdl-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3f4f020"]])

export default __exports__